module.exports = __webpack_public_path__ + "img/38ne.899eb935.svg";